export type DateValue = Date | null;
export type DateRange = [DateValue, DateValue];

export function assertIsDateValue(value: unknown): asserts value is DateValue {
	// Check if the value responds to toISOString, which is a method that only Date objects have
	// OR mocked Date objects in tests. It's not the best way to check if the value is a Date object,
	// but it should be enough for our use case without pulling in vitest into prod code.
	if ((value && typeof value === 'object' && 'toISOString' in value) || value === null) {
		return;
	}

	throw new TypeError('Value must be a Date or null');
}

export function assertIsDateRange(value: unknown): asserts value is DateRange {
	if (Array.isArray(value) && value.length === 2) {
		assertIsDateValue(value[0]);
		assertIsDateValue(value[1]);
		return;
	}

	throw new TypeError('Value must be a DateRange');
}
